/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SmilyContext { 
    displayState?: SmilyContext.DisplayStateEnum;
    level?: number;
    maxPossibleCashback?: number;
}
export namespace SmilyContext {
    export type DisplayStateEnum = 'LOGIN_REGISTER_NEEDED' | 'JUST_ENROLLED' | 'JUST_DECLINED' | 'MEMBER' | 'SIGNUP_NEEDED';
    export const DisplayStateEnum = {
        LoginRegisterNeeded: 'LOGIN_REGISTER_NEEDED' as DisplayStateEnum,
        JustEnrolled: 'JUST_ENROLLED' as DisplayStateEnum,
        JustDeclined: 'JUST_DECLINED' as DisplayStateEnum,
        Member: 'MEMBER' as DisplayStateEnum,
        SignupNeeded: 'SIGNUP_NEEDED' as DisplayStateEnum
    };
}


